import { MeterFilterParams } from "types/MeterFilterParams";
import { YesNoType } from "types/YesNoType";
import { getCDLColors } from "../../design_system/utils/colors";
import { CategoryAggregations, MeterCategories } from "./types";

export const orderedMeterCategories: MeterCategories[] = [
  "yes",
  "possibly",
  "mixed",
  "no",
];

// Get theme-aware colors - will use correct values for light/dark mode
export const getCategoriesToColors = (): Record<MeterCategories, string> => {
  const colors = getCDLColors();
  return {
    yes: colors.chartGreenBase,
    no: colors.chartRedBase,
    possibly: colors.chartYellowBase,
    mixed: colors.chartOrangeBase,
  };
};

// For backward compatibility, export a getter that returns current colors
export const categoriesToColors: Record<MeterCategories, string> =
  typeof window !== "undefined"
    ? getCategoriesToColors()
    : {
        yes: "#3BCDAA", // Fallback for SSR
        no: "#F06767",
        possibly: "#FEBA21",
        mixed: "#FF7E1C",
      };

export const orderedCategoryAggregations: CategoryAggregations[] = [
  "recency",
  "tier_one_studies",
  "journal_score",
  "citations",
];

export const categoryAggregationsToIcons: Record<CategoryAggregations, string> =
  {
    recency: "icon-calendar",
    tier_one_studies: "icon-flask-conical",
    journal_score: "icon-book-open",
    citations: "icon-quote",
  };

export const defaultMeterFilter: MeterFilterParams = {
  no: true,
  possibly: true,
  yes: true,
  unknown: true,
  mixed: true,
};

export function getIsMeterFilterActive(
  meterFilter: MeterFilterParams
): boolean {
  return !(
    meterFilter.yes &&
    meterFilter.possibly &&
    meterFilter.no &&
    meterFilter.mixed
  );
}

export function removedByYesNoMeterFilter(
  meterFilter: MeterFilterParams,
  yesNoType?: YesNoType
): boolean {
  if (!meterFilter.yes && yesNoType === "YES") {
    return false;
  }
  if (!meterFilter.no && yesNoType === "NO") {
    return false;
  }
  if (!meterFilter.possibly && yesNoType === "POSSIBLY") {
    return false;
  }
  if (!meterFilter.mixed && yesNoType === "MIXED") {
    return false;
  }
  if (yesNoType === "UNKNOWN") {
    return false;
  }
  if (!yesNoType) {
    return false;
  }
  return true;
}
